import { statusMeta } from "@/lib/calendar";

// Status pill for a calendar entry. When `onCycle` is given (and not disabled)
// it renders as a button that cycles planned → posted → not_posted on tap; the
// "Atrasado" (overdue) look is derived, never a persisted status.
//
// `expandHit` grows the tap target to >=44px (NFR2) via a centered ::before
// overlay, so the pill can stay visually compact while remaining thumb-friendly
// on touch surfaces (used by the Day view).
export default function StatusChip({ entry, today, onCycle, disabled = false, expandHit = false, testid }) {
  const meta = statusMeta(entry, today);
  const interactive = Boolean(onCycle) && !disabled;
  const Tag = interactive ? "button" : "span";
  const hit =
    interactive && expandHit
      ? "relative before:absolute before:inset-x-0 before:top-1/2 before:h-11 before:-translate-y-1/2 before:content-['']"
      : "";
  return (
    <Tag
      type={interactive ? "button" : undefined}
      data-testid={testid}
      data-status={meta.key}
      onClick={interactive ? onCycle : undefined}
      title={interactive ? "Tocar para mudar o status" : undefined}
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10.5px] font-ui tracking-wide whitespace-nowrap ${meta.className} ${
        interactive ? "cursor-pointer hover:opacity-80 transition-opacity" : ""
      } ${hit}`}
    >
      {meta.label}
    </Tag>
  );
}
